import {Box, Divider, Stack} from '@mui/material'
import CardTitle from "../../UI/CardTitle"
import {StyledLink} from '../Link/components'
import theme from "../../../theme/theme"
import ShowAllDaysLink from './ShowAllDaysLink'

export interface CardTitleWithLinkProps {
    onClick?: (open:boolean) => void
}

function CardTitleWithLink({onClick}: CardTitleWithLinkProps) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Stack direction="row" alignItems="center">
          <CardTitle title="Approval" />
        </Stack>
        <StyledLink 
          style={{
            textDecoration: 'none',
            color: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          <ShowAllDaysLink onClick={() => onClick?.(true)} />
        </StyledLink>
      </Stack>
      <Divider />
    </Box>
  )
}

export default CardTitleWithLink